import { navigationConfig } from "@/config/navigation";
import { useFilteredNavItems } from "@/hooks/useSidebar";
import type { NavEntry } from "@/types/navigation";
import { SidebarNavGroup } from "./SidebarNavGroup";
import { SidebarNavItem } from "./SidebarNavItem";

function renderEntry(entry: NavEntry) {
  if (entry.kind === "link") {
    return <SidebarNavItem key={entry.id} item={entry} />;
  }
  return <SidebarNavGroup key={entry.id} group={entry} />;
}

// A heading goes above the first visible item of each section, so a section
// the user has no access to disappears together with its heading.
function renderWithSections(entries: NavEntry[]) {
  return entries.map((entry, index) => {
    const startsSection =
      entry.section && entry.section !== entries[index - 1]?.section;
    if (!startsSection) {
      return renderEntry(entry);
    }
    return [
      <li
        key={`section-${entry.section}`}
        className="px-3 pt-5 pb-1.5 text-[11px] font-medium text-adara-300"
      >
        {entry.section}
      </li>,
      renderEntry(entry),
    ];
  });
}

export function SidebarNav() {
  const visibleMain = useFilteredNavItems(navigationConfig.main);
  const visibleSecondary = useFilteredNavItems(
    navigationConfig.secondary ?? [],
  );

  return (
    <nav className="flex flex-1 flex-col overflow-y-auto px-2.5 py-3">
      <ul className="flex flex-col gap-0.5">
        {renderWithSections(visibleMain)}
      </ul>

      {visibleSecondary.length > 0 && (
        <ul className="mt-auto flex flex-col gap-0.5 border-t border-white/10 pt-3">
          {renderWithSections(visibleSecondary)}
        </ul>
      )}
    </nav>
  );
}
